import * as actionTypes from './actionTypes';
export var setLocale = function setLocale(locale) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.SET_LOCALE,
      payload: {
        locale: locale
      }
    });
  };
};
export var setDefaultPhrases = function setDefaultPhrases(defaultPhrases) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.SET_DEFAULT_PHRASES,
      payload: {
        defaultPhrases: defaultPhrases
      }
    });
  };
};
export var fetchPhrases = function fetchPhrases(url, defaultPhrases) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.FETCH_PHRASES
    });
    return fetch(url).then(function (response) {
      return response.json();
    }).then(function (data) {
      dispatch({
        type: actionTypes.FETCH_PHRASES_SUCCESS,
        payload: {
          phrases: data
        }
      });
    }).catch(function (error) {
      dispatch({
        type: actionTypes.FETCH_PHRASES_FAIL,
        error: error
      });
      dispatch({
        type: actionTypes.SET_DEFAULT_PHRASES,
        payload: {
          defaultPhrases: defaultPhrases
        }
      });
    });
  };
};